import { adaptDataForSubmission } from "@/core/helpers/assessment-submission-adapter";
import { assessmentRequestsTyped } from "@/api/(requests)/assessmentTyped";
import type { AssessmentSubmissionParams, AssessmentSubmissionResponse } from "@/core/types";

export async function postAnswer({
  assessmentDefinitionId,
  assessmentDefinitionVersion,
  formData,
  taskId,
}: AssessmentSubmissionParams): Promise<AssessmentSubmissionResponse> {
  const body = adaptDataForSubmission({
    assessmentDefinitionId,
    assessmentDefinitionVersion,
    formData,
    taskId,
  });

  return assessmentRequestsTyped.post_answer({
    body,
    context: { showLoader: false },
  });
}
